import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import logo from "../../image/Salarytap_logo_horizontal-light_800X239_colored.jpg";
import axios from "axios";
import * as Yup from "yup";
import "./Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { APIURL } from "../../Config";

export default function Login() {
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("emailId");
  const [show, setShow] = useState(true);
  const [showWorkspaceList, setShowWorkspaceList] = useState(false);
  const [workspaceList, setWorkspaceList] = useState([]);
  const [showOtp, setShowOtp] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [otpM, setOtpM] = useState(new Array(6).fill(""));
  const otpBoxReference = useRef([]);
  const otpBoxReferenceM = useRef([]);
  const [isLoader, setIsLoader] = useState(false);
  const history = useNavigate();
  const loginTime = Date.now(); // Set expiry time 1 minute from now
  const [selectedTab, setSelectedTab] = useState(() => {
    return localStorage.getItem("selectedTab"); // Get from storage or default to "Salary Tap"
  });
  console.log("selectedTab::: ", selectedTab);

  const extractCleanName = (url) => {
    try {
      const { hostname } = new URL("http://103.114.153.189:8075/salarytap/");
      return hostname.split(":")[0].split(".")[0]; // remove port and TLDs
    } catch (e) {
      console.error("Invalid URL:", url);
      return null;
    }
  };

  useEffect(() => {
    const currentUrl = window.location.href;
    const cleanName = extractCleanName(currentUrl);
    if (!localStorage.getItem("selectedTab")) {
      if (cleanName) {
        // localStorage.setItem("siteSource", cleanName);
        if (cleanName == "salarytap") {
          setSelectedTab("Salary Tap");
        } else if (cleanName == "cashontap") {
          setSelectedTab("Cashon Tap");
        } else {
          // setSelectedTab("localhost");
        }
        console.log("Saved to localStorage:", cleanName);
      }
    }
  }, []);

  // Ensure localStorage is set on first load
  // useEffect(() => {
  //   if (!localStorage.getItem("selectedTab")) {
  //     localStorage.setItem("selectedTab", "Salary Tap");
  //   }
  // }, []);
  const loginType = localStorage.getItem("selectedTab");

  const handleTabChange = (event) => {
    const tab = event.target.value;
    setSelectedTab(tab); // Update state
    localStorage.setItem("selectedTab", tab); // Store in local storage
  };

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    // mobile: Yup.string()
    //   .matches(/^[6-9]\d{9}$/, "Invalid mobile number")
    //   .required("Mobile number is required"),
  });

  const backToWeb = () => {
    history("/");
    localStorage.clear();
  };

  useEffect(() => {
    const tokenStatus = localStorage.getItem("type");
    if (
      tokenStatus === "undefined" ||
      tokenStatus === "" ||
      !tokenStatus ||
      tokenStatus === "null"
    ) {
      history("/salarytap/login");
    } else {
      setShow(false);
      setShowOtp(false);
      if (tokenStatus == "Salarytap_admin") {
        history("/salarytap/stp-dashboard");
      } else if (tokenStatus === "Finance_Admin") {
        history("/salarytap/stp-dashboard");
      } else if (tokenStatus === "CA_Admin") {
        history("/salarytap/stp-dashboard");
      } else if (tokenStatus === "Account_Admin") {
        history("/salarytap/stp-dashboard");
      } else {
        history("/salarytap/dashboard");
      }
    }
  }, []);

  function handleChange(value, index, type) {
    if (type === "E") {
      let newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);

      if (value && index < 5) {
        otpBoxReference.current[index + 1].focus();
      }

      if (
        newArr.every((val) => val !== "") &&
        otpM.every((val) => val !== "")
      ) {
        handelSubmitOtp(newArr, otpM);
      }
    } else if (type === "M") {
      let newArrM = [...otpM];
      newArrM[index] = value;
      setOtpM(newArrM);

      if (value && index < 5) {
        otpBoxReferenceM.current[index + 1].focus();
      }

      if (
        newArrM.every((val) => val !== "") &&
        otp.every((val) => val !== "")
      ) {
        handelSubmitOtp(otp, newArrM);
      }
    }
  }

  function handleBackspaceAndEnter(e, index, type) {
    const ref = type === "M" ? otpBoxReferenceM : otpBoxReference;

    if (e.key === "Backspace" && !e.target.value && index > 0) {
      ref.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < 5) {
      ref.current[index + 1].focus();
    }
  }
  const clearOtpFields = () => {
    setOtp(Array(6).fill(""));
    otpBoxReference.current[0].focus();
    setOtpM(Array(6).fill(""));
    otpBoxReferenceM.current[0].focus();
  };

  const loginData = {
    email: email,
    loginstatus: "true",
  };

  const loginUpdate = () => {
    axios
      .request(`${APIURL}/loginupdate`, {
        method: "POST",
        data: loginData,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
        credentials: "include",
      })
      .then((response) => {
        console.log("response login update::", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handelSubmitOtp = async (otpArrE, otpArrM) => {
    const hasEmpty =
      otpArrE.some((v) => v === "") || otpArrM.some((v) => v === "");
    if (hasEmpty) {
      toast.error("All OTP fields must be filled");
      return;
    }

    const data = {
      emailOtp: parseInt(otpArrE.join("")),
      mobileOtp: parseInt(otpArrM.join("")),
    };

    // Now you can post both OTPs in the request
    const email = localStorage.getItem("emailId");
    const dto = JSON.stringify({
      email,
      otp: String(data.emailOtp),
      mobileotp: String(data.mobileOtp),
    });

    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/otpverify`, {
        method: "POST",
        data: dto,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
        credentials: "include",
      })
      .then((response) => {
        setIsLoader(false);
        if (response?.data?.success) {
          toast.success(response?.data?.message);
          clearOtpFields();
          setShowOtp(false);
          loginUpdate();
          localStorage.setItem("type", response.data.type);
          localStorage.setItem("workspace", response?.data?.workspaceid);
          localStorage.setItem("userId", response?.data?.userId);
          localStorage.setItem("token", response?.data?.token);
          localStorage.setItem("loginTime", loginTime);

          if (
            [
              "Salarytap_admin",
              "Finance_Admin",
              "CA_Admin",
              "Account_Admin",
            ].includes(response.data.type)
          ) {
            history("/salarytap/stp-dashboard");
          } else {
            history("/salarytap/dashboard");
          }
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getWorkspaceInfo = (newtoken) => {
    const dto = {
      email: email,
    };

    axios
      .request(`${APIURL}/corporate/workspacedetails`, {
        method: "POST",
        data: dto,
        headers: {
          Authentication: newtoken ?? token,
          "Content-Type": "application/json",
        },
        credentials: "include",
      })
      .then((response) => {
        if (typeof response?.data == "string") {
          localStorage.clear();
          setShow(true);
          setShowOtp(false);
          setShowWorkspaceList(false);
        } else {
          setWorkspaceList(response?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const Login = (item) => {
    localStorage.setItem("workspace", item?.workspace);
    history("/salarytap/dashboard");
  };

  const clicktoDelete = (item) => {
    const data = {
      emailid: item?.emailId,
      workspaceId: item?.workspace,
    };
    console.log(data);
    axios
      .request(`${APIURL}/employee/deleteworkspace`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
        credentials: "include",
      })
      .then((response) => {
        console.log("response", response);
        toast.warning(response?.data);
        setShowModal(false);
      })
      .catch((error) => {
        setShowModal(false);
        console.log(error);
      });
  };

  if (workspaceList?.length === 1) {
    localStorage.setItem("workspace", workspaceList[0]?.workspace);
  }
  return (
    <>
      {show && (
        <Formik
          initialValues={{ email: "" }}
          validationSchema={LoginSchema}
          onSubmit={(values) => {
            const data = {
              email: values.email,
              createflag: "login",
              // mobileno: values.mobile,
            };

            setIsLoader(true);
            axios
              .request(`${APIURL}/corporate/login`, {
                method: "POST",
                data: data,
                headers: {
                  Authentication: token,

                  "Content-Type": "application/json",
                },
                credentials: "include",
              })
              .then((response) => {
                console.log("response", response);
                console.log("value emmail:", values?.email);
                if (response?.data?.type === null) {
                  history("/");
                  toast.warning("Workspace not found...");
                } else {
                  setIsLoader(false);
                  localStorage.setItem("emailId", response?.data?.emailId);
                  if (response.data.type == "Workspace_Owner") {
                    localStorage.setItem(
                      "corporateId",
                      response?.data?.corporateId
                    );
                  } else if (response.data.type == "Employer_Admin") {
                    localStorage.setItem(
                      "corporateId",
                      response?.data?.ownerCorporateId
                    );
                  }
                  localStorage.setItem("type", response.data.type);
                  toast.success("Otp send successfully...");
                  setShow(false);
                  setShowOtp(true);
                }
              })
              .catch((error) => {
                console.log("error", error);
                setIsLoader(false);
                toast.warning("Kindly retry after some time.");
              });
          }}
        >
          {({ touched, errors }) => (
            <>
              <div className="Loginform-container">
                <Form className="Loginform ">
                  <div>
                    <div>
                      <h4
                        className="mt-3 mb-4 text-center"
                        style={{ color: "black", fontWeight: 800 }}
                      >
                        Login
                      </h4>

                      {console.log("selectedTab::: ", selectedTab)}
                      {selectedTab == "localhost" && (
                        <>
                          <label htmlFor="tabSelection">Select Tab*</label>
                          <select
                            id="tabSelection"
                            className="form-control mb-2 mt-1"
                            value={selectedTab}
                            onChange={handleTabChange}
                          >
                            <option value="Salary Tap">Salarytap</option>
                            <option value="Cashon Tap">CashOnTap</option>
                          </select>
                        </>
                      )}
                      {console.log("sewleced tab:::::", selectedTab)}

                      <label>Email*</label>
                      <Field
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        className={`form-control mt-1
                          ${touched.email && errors.email ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage
                        component="div"
                        name="email"
                        className="invalid-feedback"
                      />

                      {/* <label className="mt-2">Mobile Number*</label>
                      <Field
                        type="number"
                        name="mobile"
                        placeholder="Enter 10-digit mobile"
                        className={`form-control mt-1 ${
                          touched.mobile && errors.mobile ? "is-invalid" : ""
                        }`}
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        component="div"
                        name="mobile"
                        className="invalid-feedback"
                      /> */}

                      <button
                        className="btn btn-success mt-3"
                        type="submit"
                        style={{ background: "#66a725", color: "black" }}
                      >
                        {isLoader ? (
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          "Sign In"
                        )}
                      </button>
                      {/* <hr /> */}
                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-4">
                        <div className="d-flex flex-column flex-sm-row align-items-center">
                          <div>Don't have a workspace?</div>
                          &nbsp;
                          <Link
                            className=""
                            to={"/salarytap/createYourWorkspace"}
                            style={{ color: "#66a725" }}
                          >
                            Create a new Workspace
                          </Link>
                        </div>
                        <button
                          className="btn btn-light mt-3 mt-sm-0"
                          type="button"
                          style={{ width: "70px" }}
                          onClick={() => backToWeb()}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>
      )}
      {showOtp && (
        <div className="Loginform-container">
          <div className="Loginform">
            <div className="d-flex justify-content-center mb-4">
              <img src={logo} alt="logo" width="35%" height="100%" />
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="d-flex justify-content-center mb-5">
                  <span className="fs-3 fw-semibold">
                    Check your email & mobile for a code
                  </span>
                </div>
                <div>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                    className=""
                  >
                    Enter OTP code sent to your email & mobile
                  </p>
                </div>

                <div className="row">
                  <div className="col-lg-12 text-center">
                    <div
                      className=""
                      style={{
                        flexDirection: "row",
                        columnGap: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <label>Mobile OTP</label>
                      {otpM.map((digit, index) => (
                        <input
                          key={index}
                          value={digit}
                          maxLength={1}
                          onChange={(e) =>
                            handleChange(e.target.value, index, "M")
                          }
                          onKeyUp={(e) =>
                            handleBackspaceAndEnter(e, index, "M")
                          }
                          ref={(reference) =>
                            (otpBoxReferenceM.current[index] = reference)
                          }
                          style={{ height: "45px", width: "44px" }}
                          className={`border w-12 h-12 text-4xl text-black p-3 rounded-md block bg-light focus:border-2 focus:outline-none appearance-none text-center`}
                        />
                      ))}
                    </div>
                    <div
                      className="mt-3"
                      style={{
                        flexDirection: "row",
                        columnGap: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <label>Email OTP</label>

                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          value={digit}
                          maxLength={1}
                          onChange={(e) =>
                            handleChange(e.target.value, index, "E")
                          }
                          onKeyUp={(e) =>
                            handleBackspaceAndEnter(e, index, "E")
                          }
                          ref={(reference) =>
                            (otpBoxReference.current[index] = reference)
                          }
                          style={{ height: "45px", width: "44px" }}
                          className={`border w-12 h-12 text-4xl text-black p-3 rounded-md block bg-light focus:border-2 focus:outline-none appearance-none text-center`}
                        />
                      ))}
                    </div>

                    <button
                      onClick={() => handelSubmitOtp(otp, otpM)}
                      className="btn btn-success mt-3 w-50"
                      type="submit"
                      style={{ background: "#66a725", color: "#fff" }}
                    >
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-light mt-2"
                        type="button"
                        style={{ width: "70px" }}
                        onClick={() => {
                          setShow(true);
                          setShowOtp(false);
                          clearOtpFields();
                        }}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
      )}
      {showWorkspaceList && (
        <div className="">
          <div className="pb-5 pt-4">
            <div className="d-flex justify-content-center pb-4">
              <h3>Open a workspace</h3>
            </div>
            {workspaceList?.length === 1 ? (
              history("/salarytap/dashboard")
            ) : (
              <>
                <div className="d-flex justify-content-center">
                  <div className="card bg-light" style={{ width: "42rem" }}>
                    {workspaceList?.map((item, i) => (
                      <>
                        <div
                          className="card-body"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="px-2">
                            <h5 className="card-title">{item?.emailId}</h5>
                            <p className="card-text">{item?.corporateName}</p>
                          </div>
                          <div className="ps-5 pe-3 d-flex">
                            <button
                              className="btn btn-primary"
                              style={{
                                background: "#66a725",
                                color: "#fff",
                                border: "0px",
                              }}
                              onClick={() => Login(item)}
                            >
                              Login
                            </button>
                            <button
                              onClick={() => setShowModal(true)}
                              className="btn btn-danger ml-2"
                              style={{
                                color: "#fff",
                                border: "0px",
                              }}
                            >
                              Delete
                            </button>
                            <Modal
                              show={showModal}
                              onHide={() => setShowModal(false)}
                            >
                              <Modal.Body closeButton>
                                <p
                                  className="px-2 py-2 m-0"
                                  style={{
                                    fontSize: "22px",
                                    fontWeight: "500",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  Are you sure?
                                </p>
                              </Modal.Body>
                              <Modal.Footer className="d-flex justify-content-end">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  className="px-2"
                                >
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => setShowModal(false)}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btn-danger ml-2"
                                    onClick={() => clicktoDelete(item)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </div>
                        {i < workspaceList?.length - 1 && (
                          <div className="px-5">
                            <hr />
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
